import {
  Component,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';

@Component({
  selector: 'app-product-card',
  templateUrl: './app-product-card.component.html',
  styleUrls: ['./app-product-card.component.scss'],
})
export class AppProductCardComponent {
  /** The item or SKU data object */
  @Input() item: any;

  /** Mode: 'item' (full item master card) or 'sku' (SKU card) */
  @Input() variant: 'item' | 'sku' = 'item';

  /** Optional parent product images for SKU fallback */
  @Input() parentProductImages?: any[];

  /** Access permission for action buttons */
  @Input() accessPermission: string = 'SALES_PRODUCTS';

  /** Visibility controls */
  @Input() showActions: boolean = true;
  @Input() showEditAction: boolean = true;
  @Input() showDeleteAction: boolean = true;
  @Input() clickable: boolean = true;

  /** Event Emitters */
  @Output() cardClick = new EventEmitter<any>();
  @Output() edit = new EventEmitter<any>();
  @Output() delete = new EventEmitter<any>();

  get isOutOfStock(): boolean {
    return this.item?.qty === 0 || this.item?.prod_qty === 0;
  }

  onCardClick(): void {
    if (this.clickable) {
      this.cardClick.emit(this.item);
    }
  }

  onEdit(event?: any): void {
    if (event && typeof event.stopPropagation === 'function') {
      event.stopPropagation();
    }
    this.edit.emit(this.item);
  }

  onDelete(event?: any): void {
    if (event && typeof event.stopPropagation === 'function') {
      event.stopPropagation();
    }
    this.delete.emit(this.item);
  }
}
